export function ItemResponseAtendente({ label, value, hora }) {
  return (
    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
      <dt>
        <div className="flex flex-col">
          <p className="text-sm/6 font-medium text-gray-900">{label}</p>
          <span className="text-muted-foreground text-[9px]">{hora}</span>
        </div>
      </dt>
      <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
        <div
          className="prose max-w-none"
          dangerouslySetInnerHTML={{ __html: value }}
        />
      </dd>
    </div>
  )
}